// vot.mt — partner promo banner.
//
// Static image + link-out to vot.mt/elections. Occupies a strip slot in
// the dashboard's main column, between the quiz and the district map.
// The source image is a ~1.91:1 social-card asset — shown full-width at
// its natural aspect ratio (not cropped) inside a rounded card.

import './VotmtBanner.css';

const VOTMT_URL = 'https://vot.mt/elections';

export default function VotmtBanner() {
  return (
    <a
      className="votmt-banner"
      href={VOTMT_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="vot.mt — Malta elections"
    >
      <img
        className="votmt-banner__img"
        src="/assets/votmt.jpeg"
        alt="vot.mt — Malta elections"
        loading="lazy"
      />
    </a>
  );
}
